import { useState } from "react";
import { PdfExportButton } from "@/components/pdf-export-button";
import { exportEntryReport } from "@/src/services/monitoring_service";
import { toUserMessage } from "@/src/services/error_messages";
import { useToast } from "@/components/action-feedback";

export function ExportPdfButton({ entryId, disabled }: { entryId: string; disabled: boolean }) {
  const [isExporting, setIsExporting] = useState(false);
  const [exportRequested, setExportRequested] = useState(false);
  const showToast = useToast();

  async function handleClick() {
    setIsExporting(true);
    const res = await exportEntryReport(entryId);
    setIsExporting(false);
    if (!res.ok) {
      showToast({ tone: "error", text: toUserMessage(res.error) });
      return;
    }
    setExportRequested(true);
    showToast({
      tone: "success",
      text: "Preparing the PDF report — it'll be ready in notifications shortly",
    });
  }

  return (
    <PdfExportButton
      onClick={() => void handleClick()}
      disabled={disabled || isExporting || exportRequested}
    />
  );
}
